import React from 'react';
import SiteNav from '../components/SiteNav';
import SiteFooter from '../components/SiteFooter';
import { getBlogPostBySlug } from '../data/blogPosts';
import type { BlogContentBlock } from '../data/blogPosts';

interface BlogPostPageProps {
  slug: string;
}

function renderBlock(block: BlogContentBlock, index: number) {
  switch (block.type) {
    case 'heading':
      return <h2 key={index}>{block.text}</h2>;
    case 'paragraph':
      return <p key={index}>{block.text}</p>;
    case 'list':
      return (
        <ul key={index}>
          {block.items?.map((item, i) => <li key={i}>{item}</li>)}
        </ul>
      );
    case 'ordered-list':
      return (
        <ol key={index}>
          {block.items?.map((item, i) => <li key={i}>{item}</li>)}
        </ol>
      );
    default:
      return null;
  }
}

const BlogPostPage: React.FC<BlogPostPageProps> = ({ slug }) => {
  const post = getBlogPostBySlug(slug);

  // SEO (title, description, canonical, schema) is handled by PageSEO wrapper in App.tsx

  if (!post) {
    return (
      <div className="landing-page">
        <SiteNav currentPage="home" />
        <section className="page-hero">
          <div className="container">
            <h1 className="page-hero-title">Post Not Found</h1>
            <p className="page-hero-subtitle" style={{ fontStyle: 'normal' }}>
              <a href="/blog" style={{ color: 'white' }}>Back to all posts</a>
            </p>
          </div>
        </section>
        <SiteFooter />
      </div>
    );
  }

  const formattedDate = new Date(post.date).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <div className="landing-page">
      <SiteNav currentPage="home" />

      {/* Hero */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-hero-title" style={{ fontSize: '2.25rem' }}>{post.title}</h1>
          <p className="page-hero-subtitle" style={{ fontStyle: 'normal' }}>
            {formattedDate} &middot; {post.author}
          </p>
        </div>
      </section>

      {/* Post Content */}
      <section className="blog-post-section">
        <div className="container">
          <a href="/blog" className="blog-post-back">&larr; All posts</a>
          <div className="blog-post-content">
            {post.content.map((block, i) => renderBlock(block, i))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <h2 className="section-title" style={{ color: 'white' }}>Ready to give them a head start?</h2>
          <p className="section-subtitle" style={{ color: 'rgba(255,255,255,0.8)' }}>
            Join early access &mdash; free to start, no credit card needed.
          </p>
          <a href="/#waitlist" className="btn-primary-light">
            Get Early Access
          </a>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default BlogPostPage;
